import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors (client errors)
        if (error && typeof error === 'object' && 'status' in error) {
          const status = error.status as number;
          if (status >= 400 && status < 500) {
            return false;
          }
        }
        // Retry up to 3 times for other errors
        return failureCount < 3;
      },
    },
    mutations: {
      retry: (failureCount, error) => {
        // Generally don't retry mutations to avoid side effects
        // Only retry on network errors, not client/server errors
        if (error && typeof error === 'object' && 'status' in error) {
          return false;
        }
        // Retry once for pure network failures
        return failureCount < 1;
      },
    },
  },
});
